import DottedEdge from "./DottedEdge";
import SolidEdge from "./SolidEdge";

export const EDGE_TYPES_MAP = {
  dotted: DottedEdge,
  solid: SolidEdge,
};

export const DEFAULT_EDGE_TYPE = "solid" as const;
